export default __webpack_public_path__ + "static/media/warning--crossroads-with-priority-to-the-right--g1.7597a71a.png";